import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { markConversationRead } from '~/modules/chat/api/mark-conversation-read.server';

export const MARK_CONVERSATION_READ_API =
    '/remix-api/chat/mark-conversation-read';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
});

/**
 * API endpoint to mark a conversation as read for the current user. Use with the
 * `useConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await markConversationRead({
            context,
            conversationID: result.data.conversationID,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({ conversation: response.conversation });
    } catch (error) {
        logger.error(`Error in ${MARK_CONVERSATION_READ_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
